import { createSelector, createSlice } from '@reduxjs/toolkit'

import * as routes from '../config/constants'
import { apiCallBegan } from './api'

interface IsState {
  loading: boolean
  list: []
  message: string | undefined
  error: string | undefined
  latitude: string | undefined
  longitude: string | undefined
  tripList: []
  positionList: []
  engine: []
  lastObd: []
  lastReObd: []
  repairingObd: string | undefined
  lastTrouble: []
  lastTrouble1: []
  paginatedTrouble: []
  topObd: [] | undefined
  obdChart: []
  odo: []
  traveledDistance: string | undefined
  device: []
  deviceStatus: []
  topObdsChart: []
  offRepairing: object | undefined
  troubleCodeClear: string | undefined
  listGeofence: any[]
  activitiesGeofence: []
  activitiesGeofenceList: []
  createGeofence: string | undefined
  lastPosition: string | undefined
  openTrips: any[]
  listTrips: []
  onStatus: []
  refreshToken: boolean
  periodicList: any[]
  onlyDevice: object | any
  overSpeedAlarms: []
  setOverSpeed: []
  lastPositionDevice: [] | undefined
  deviceSearch: []
  positionSearch: []
  troubleCodeRead: string | undefined
  troubleCodeClear1: string | undefined
  devicePaginatedList: []
  devicePaginated: []
}
const initialState: IsState = {
  loading: false,
  list: [],
  message: undefined,
  error: undefined,
  latitude: undefined,
  longitude: undefined,
  tripList: [],
  positionList: [],
  engine: [],
  lastObd: [],
  lastReObd: [],
  repairingObd: undefined,
  lastTrouble: [],
  lastTrouble1: [],
  paginatedTrouble: [],
  topObd: undefined,
  obdChart: [],
  odo: [],
  traveledDistance: undefined,
  device: [],
  deviceStatus: [],
  topObdsChart: [],
  offRepairing: undefined,
  troubleCodeClear: undefined,
  listGeofence: [],
  activitiesGeofence: [],
  activitiesGeofenceList: [],
  createGeofence: undefined,
  lastPosition: undefined,
  openTrips: [],
  listTrips: [],
  onStatus: [],
  refreshToken: false,
  periodicList: [],
  onlyDevice: [],
  overSpeedAlarms: [],
  setOverSpeed: [],
  lastPositionDevice: undefined,
  deviceSearch: [],
  positionSearch: [],
  troubleCodeRead: undefined,
  troubleCodeClear1: undefined,
  devicePaginatedList: [],
  devicePaginated: [],
}

const slice = createSlice({
  name: 'devices',
  initialState,

  reducers: {
    registerDeviceReceived: (devices, action) => {
      devices.loading = false
      devices.message = ' اطلاعات با موفقیت ثبت شد ،لطفا مشخصات خودرو را بروز رسانی کنید'
    },
    registerDeviceRequestFailed: (devices, action) => {
      devices.loading = false
      devices.error = 'اطلاعات ثبت نشد'
    },
    registerDeviceRequested: (devices) => {
      devices.loading = true
    },
    deviceListReceived: (devices, action) => {
      devices.loading = false
      devices.list = action.payload.data
    },
    deviceListRequestFailed: (devices, action) => {
      devices.loading = false
      devices.refreshToken = true
    },
    deviceListRequested: (devices) => {
      devices.loading = true
    },
    devicePaginatedListReceived: (devices, action) => {
      devices.loading = false
      devices.devicePaginatedList = action.payload.data
      devices.devicePaginated = action.payload
    },
    devicePaginatedListRequestFailed: (devices, action) => {
      devices.loading = false
      devices.refreshToken = true
    },
    devicePaginatedListRequested: (devices) => {
      devices.loading = true
    },
    resetDeviceReceived: (devices, action) => {
      devices.loading = false
      devices.device = []
    },
    resetDeviceRequestFailed: (devices, action) => {
      devices.loading = false
    },
    resetDeviceRequested: (devices) => {
      devices.loading = true
    },
    updateDeviceReceived: (devices, action) => {
      devices.loading = false
      devices.message = 'اطلاعات با موفقیت افزوده شد'
    },
    updateDeviceRequestFailed: (devices, action) => {
      devices.loading = false
      devices.error = 'اطلاعات ثبت نشد'
    },
    updateDeviceRequested: (devices) => {
      devices.loading = true
    },
    errorSet: (devices, action) => {
      devices.error = action.payload
    },
    messageSet: (devices, action) => {
      devices.message = action.payload
    },
    getLastPositionReceived: (devices, action) => {
      devices.loading = false
      devices.latitude = action.payload.gps.latitude
      devices.longitude = action.payload.gps.longitude

      // devices.message = 'اطلاعات با موفقیت افزوده شد'
    },
    getLastPositionRequestFailed: (devices, action) => {
      devices.loading = false
      devices.latitude = ''
      devices.longitude = ''
      // devices.error = 'اطلاعات ثبت نشد'
    },
    getLastPositionRequested: (devices) => {
      devices.loading = true
    },
    getLastPositionDeviceReceived: (devices, action) => {
      devices.loading = false
      devices.lastPositionDevice = action.payload

      // devices.message = 'اطلاعات با موفقیت افزوده شد'
    },
    getLastPositionDeviceRequestFailed: (devices, action) => {
      devices.loading = false
    },
    getLastPositionDeviceRequested: (devices) => {
      devices.loading = true
    },
    tripsListSetReceived: (devices, action) => {
      devices.tripList = action.payload
    },
    positionListReceived: (devices, action) => {
      devices.loading = false
      devices.positionList = action.payload.data
    },
    positionListRequestFailed: (devices, action) => {
      devices.loading = false
    },
    positionListRequested: (devices) => {
      devices.loading = true
    },
    troubleCodeReadReceived: (devices, action) => {
      devices.loading = false
      devices.troubleCodeRead = action.payload
    },
    troubleCodeReadRequestFailed: (devices, action) => {
      devices.loading = false
    },
    troubleCodeReadRequested: (devices) => {
      devices.loading = true
    },
    troubleCodeClearReceived: (devices, action) => {
      devices.loading = false
      devices.troubleCodeClear1 = action.payload
    },
    troubleCodeClearRequestFailed: (devices, action) => {
      devices.loading = false
    },
    troubleCodeClearRequested: (devices) => {
      devices.loading = true
    },
    positionListReset: (devices, action) => {
      devices.positionList = action.payload
    },
    engineDetailsReceived: (devices, action) => {
      devices.loading = false
      devices.engine = action.payload
    },
    engineDetailsRequestFailed: (devices, action) => {
      devices.loading = false
    },
    engineDetailsRequested: (devices) => {
      devices.loading = true
    },
    resetEngine: (devices, action) => {
      devices.engine = []
    },
    troubleCodeReset: (devices, action) => {
      devices.troubleCodeRead = undefined
      devices.troubleCodeClear1 = undefined
    },
    lastObdReceived: (devices, action) => {
      devices.loading = false
      devices.lastObd = action.payload
    },
    lastObdRequestFailed: (devices, action) => {
      devices.loading = false
    },
    lastObdRequested: (devices) => {
      devices.loading = true
    },
    repairingObdReceived: (devices, action) => {
      devices.loading = false
      devices.repairingObd = action.payload
    },
    repairingObdRequestFailed: (devices, action) => {
      devices.loading = false
    },
    repairingObdRequested: (devices) => {
      devices.loading = true
    },
    lastReObdReceived: (devices, action) => {
      devices.loading = false
      devices.lastObd = action.payload
      // devices.repairingObd = action.payload
    },
    lastReObdRequestFailed: (devices, action) => {
      devices.loading = false
    },
    lastReObdRequested: (devices) => {
      devices.loading = true
    },
    repairingObdSet: (devices, action) => {
      devices.repairingObd = undefined
    },
    engineSet: (devices, action) => {
      devices.engine = []
    },
    lastTroubleReceived: (devices, action) => {
      devices.loading = false
      devices.lastTrouble = action.payload.data
    },
    lastTroubleRequestFailed: (devices, action) => {
      devices.loading = false
    },
    lastTroubleRequested: (devices) => {
      devices.loading = true
    },
    lastTrouble1Received: (devices, action) => {
      devices.loading = false
      devices.lastTrouble1 = action.payload.data
    },
    lastTrouble1RequestFailed: (devices, action) => {
      devices.loading = false
    },
    lastTrouble1Requested: (devices) => {
      devices.loading = true
    },
    lastObdSet: (devices, action) => {
      devices.lastObd = []
    },
    lastTroubleSet: (devices, action) => {
      devices.lastTrouble = []
    },
    paginatedTroubleReceived: (devices, action) => {
      devices.loading = false
      devices.paginatedTrouble = action.payload
    },
    paginatedTroubleRequestFailed: (devices, action) => {
      devices.loading = false
    },
    paginatedTroubleRequested: (devices) => {
      devices.loading = true
    },
    paginatedTroubleSet: (devices, action) => {
      devices.paginatedTrouble = []
    },
    topObdReceived: (devices, action) => {
      devices.loading = false
      devices.topObd = action.payload
    },
    topObdRequestFailed: (devices, action) => {
      devices.loading = false
    },
    topObdRequested: (devices) => {
      devices.loading = true
    },
    topObdSet: (devices) => {
      devices.topObd = undefined
    },
    paginatedObdChartReceived: (devices, action) => {
      devices.loading = false
      devices.obdChart = action.payload
    },
    paginatedObdChartRequestFailed: (devices, action) => {
      devices.loading = false
    },
    paginatedObdChartRequested: (devices) => {
      devices.loading = true
    },
    obdChartSet: (devices) => {
      devices.obdChart = []
    },
    odoReceived: (devices, action) => {
      devices.loading = false
      devices.odo = action.payload
    },
    odoRequestFailed: (devices, action) => {
      devices.loading = false
    },
    odoRequested: (devices) => {
      devices.loading = true
    },
    traveledDistanceReceived: (devices, action) => {
      devices.loading = false
      devices.traveledDistance = action.payload
    },
    traveledDistanceRequestFailed: (devices, action) => {
      devices.loading = false
    },
    traveledDistanceRequested: (devices) => {
      devices.loading = true
    },

    deviceReceived: (devices, action) => {
      devices.loading = false
      devices.device = action.payload.properties
      devices.onlyDevice = action.payload
    },
    deviceRequestFailed: (devices, action) => {
      devices.loading = false
    },
    deviceRequested: (devices) => {
      devices.loading = true
    },
    deviceSet: (devices) => {
      devices.device = []
    },
    traveledDistanceSet: (devices) => {
      devices.traveledDistance = undefined
    },
    deviceStatusReceived: (devices, action) => {
      devices.loading = false
      devices.deviceStatus = action.payload
    },
    deviceStatusRequestFailed: (devices, action) => {
      devices.loading = false
    },
    deviceStatusRequested: (devices) => {
      devices.loading = true
    },
    topObdsChartReceived: (devices, action) => {
      devices.loading = false
      devices.topObdsChart = action.payload
    },
    topObdsChartRequestFailed: (devices, action) => {
      devices.loading = false
    },
    topObdsChartRequested: (devices) => {
      devices.loading = true
    },
    offRepairingReceived: (devices, action) => {
      devices.loading = false
      devices.offRepairing = action.payload
    },
    offRepairingRequestFailed: (devices, action) => {
      devices.loading = false
    },
    offRepairingRequested: (devices) => {
      devices.loading = true
    },
    deviceReset: (devices) => {
      devices.device = []
    },
    LastReObdReset: (devices) => {
      devices.lastObd = []
    },
    setTroubleCodeClearReceived: (devices, action) => {
      devices.loading = false
      devices.troubleCodeClear = action.payload
    },
    setTroubleCodeClearRequestFailed: (devices, action) => {
      devices.loading = false
    },
    setTroubleCodeClearRequested: (devices) => {
      devices.loading = true
    },
    createGeofenceReceived: (devices, action: any) => {
      devices.loading = false
      devices.createGeofence = action.payload
      devices.listGeofence.push(action.payload.item3)
    },
    createGeofenceRequestFailed: (devices, action) => {
      devices.loading = false
    },
    createGeofenceRequested: (devices) => {
      devices.loading = true
    },
    listGeofenceReceived: (devices, action) => {
      devices.loading = false
      devices.listGeofence = action.payload
    },
    listGeofenceRequestFailed: (devices, action) => {
      devices.loading = false
    },
    listGeofenceRequested: (devices) => {
      devices.loading = true
    },
    deleteGeofenceReceived: (devices, action: any) => {
      devices.loading = false
      const array1 = devices.listGeofence

      const isLargeNumber = (element: any) => element.id === action.payload.item3.id

      const index = array1.findIndex(isLargeNumber)
      devices.listGeofence.splice(index, 1)
    },
    deleteGeofenceRequestFailed: (devices, action) => {
      devices.loading = false
    },
    deleteGeofenceRequested: (devices) => {
      devices.loading = true
    },
    activitiesGeofenceReceived: (devices, action) => {
      devices.loading = false
      devices.activitiesGeofence = action.payload
    },
    activitiesGeofenceRequestFailed: (devices, action) => {
      devices.loading = false
    },
    activitiesGeofenceRequested: (devices) => {
      devices.loading = true
    },
    activitiesGeofenceListReceived: (devices, action) => {
      devices.loading = false
      devices.activitiesGeofenceList = action.payload
    },
    activitiesGeofenceListRequestFailed: (devices, action) => {
      devices.loading = false
    },
    activitiesGeofenceListRequested: (devices) => {
      devices.loading = true
    },
    listGeofenceReset: (devices) => {
      devices.listGeofence = []
    },
    latLngReset: (devices) => {
      devices.latitude = undefined
      devices.longitude = undefined
    },
    activitiesGeofenceReset: (devices) => {
      devices.activitiesGeofence = []
    },
    activitiesGeofenceListReset: (devices) => {
      devices.activitiesGeofenceList = []
    },
    deleteGeofence: (devices) => {
      devices.listGeofence.pop()
    },
    lastPositionGetReceived: (devices, action) => {
      devices.loading = false
      devices.lastPosition = action.payload
    },
    lastPositionGetRequestFailed: (devices, action) => {
      devices.loading = false
    },
    lastPositionGetRequested: (devices) => {
      devices.loading = true
    },
    lastPositionReset: (devices) => {
      devices.lastPosition = undefined
    },
    openTripsGetReceived: (devices, action) => {
      devices.loading = false
      devices.openTrips = action.payload
    },
    openTripsGetRequestFailed: (devices, action) => {
      devices.loading = false
    },
    openTripsGetRequested: (devices) => {
      devices.loading = true
    },
    startTripReceived: (devices, action) => {
      devices.loading = false
      devices.openTrips = action.payload.item3
    },
    startTripRequestFailed: (devices, action) => {
      devices.loading = false
    },
    startTripRequested: (devices) => {
      devices.loading = true
    },
    openTripReset: (devices) => {
      devices.openTrips = []
    },
    endTripReceived: (devices, action) => {
      devices.loading = false
      devices.openTrips = []
    },
    endTripRequestFailed: (devices, action) => {
      devices.loading = false
    },
    endTripRequested: (devices) => {
      devices.loading = true
    },
    listTripReceived: (devices, action) => {
      devices.loading = false
      devices.listTrips = action.payload.data
    },
    listTripRequestFailed: (devices, action) => {
      devices.loading = false
    },
    listTripRequested: (devices) => {
      devices.loading = true
    },
    onStatusReset: (devices) => {
      devices.onStatus = []
    },
    tripListReset: (devices) => {
      devices.listTrips = []
    },
    deleteTripReceived: (devices, action) => {
      devices.loading = false
      const array1 = devices.listTrips

      const isLargeNumber = (element: any) => element.id === action.payload.item3.id

      const index = array1.findIndex(isLargeNumber)
      devices.listTrips.splice(index, 1)
    },
    deleteTripRequestFailed: (devices, action) => {
      devices.loading = false
    },
    deleteTripRequested: (devices) => {
      devices.loading = true
    },
    deleteTripOpenReceived: (devices, action) => {
      devices.loading = false

      devices.openTrips = []
    },
    deleteTripOpenRequestFailed: (devices, action) => {
      devices.loading = false
    },
    deleteTripOpenRequested: (devices) => {
      devices.loading = true
    },
    odoReset: (devices) => {
      devices.odo = []
    },
    createPeriodicRequested: (devices) => {
      devices.loading = true
    },
    createPeriodicReceived: (devices, action: any) => {
      devices.loading = false
      devices.message = 'اطلاعات با موفقیت ثبت شد'
      devices.periodicList.push(action.payload.item3)
    },
    createPeriodicRequestFailed: (devices, action) => {
      devices.loading = false
      devices.error = 'اطلاعات ثبت نشد'
    },
    updatePeriodicRequested: (devices) => {
      devices.loading = true
    },
    updatePeriodicReceived: (devices, action: any) => {
      devices.loading = false
      devices.message = 'اطلاعات با موفقیت ویرایش شد'
      const array1 = devices.periodicList

      const isLargeNumber = (element: any) => element.id === action.payload.item3.id

      const index = array1.findIndex(isLargeNumber)
      devices.periodicList.splice(index, 1, action.payload.item3)
    },
    updatePeriodicRequestFailed: (devices, action) => {
      devices.loading = false
      devices.error = 'اطلاعات ویرایش نشد'
    },
    periodicListRequested: (devices) => {
      devices.loading = true
    },
    periodicListReceived: (devices, action) => {
      devices.loading = false
      devices.periodicList = action.payload.data
    },
    periodicListRequestFailed: (devices, action) => {
      devices.loading = false
    },
    deletePeriodicReceived: (devices, action) => {
      devices.loading = false
      const array1 = devices.periodicList

      const isLargeNumber = (element: any) => element.id === action.payload.item3.id

      const index = array1.findIndex(isLargeNumber)
      devices.periodicList.splice(index, 1)
    },
    deletePeriodicRequestFailed: (devices, action) => {
      devices.loading = false
    },
    deletePeriodicRequested: (devices) => {
      devices.loading = true
    },
    periodicListReset: (devices) => {
      devices.periodicList = []
    },
    setOverSpeedLimitReceived: (devices, action) => {
      devices.loading = false
      devices.message = 'عملیات موفقیت آمیز بود'
      devices.setOverSpeed = action.payload.item3
    },
    setOverSpeedLimitRequestFailed: (devices, action) => {
      devices.loading = false
      devices.error = 'عملیات موفقیت آمیز نبود'
    },
    setOverSpeedLimitRequested: (devices) => {
      devices.loading = true
    },
    offOverSpeedLimitReceived: (devices, action) => {
      devices.loading = false
      devices.message = 'محدودیت سرعت برداشته شد'
    },
    offOverSpeedLimitRequestFailed: (devices, action) => {
      devices.loading = false
      devices.error = 'عملیات موفقیت آمیز نبود'
    },
    offOverSpeedLimitRequested: (devices) => {
      devices.loading = true
    },
    overSpeedAlarmsReceived: (devices, action) => {
      devices.loading = false
      devices.overSpeedAlarms = action.payload
    },
    overSpeedAlarmsRequestFailed: (devices, action) => {
      devices.loading = false
    },
    overSpeedAlarmsRequested: (devices) => {
      devices.loading = true
    },
    deviceSearchReceived: (devices, action) => {
      devices.loading = false
      devices.deviceSearch = action.payload.data
    },
    deviceSearchRequestFailed: (devices, action) => {
      devices.loading = false
    },
    deviceSearchRequested: (devices) => {
      devices.loading = true
    },
    positionSearchReceived: (devices, action) => {
      devices.loading = false
      devices.positionSearch = action.payload.data
    },
    positionSearchRequestFailed: (devices, action) => {
      devices.loading = false
    },
    positionSearchRequested: (devices) => {
      devices.loading = true
    },
    positionSearchReset: (devices) => {
      devices.positionSearch = []
    },
    overSpeedAlarmsReset: (devices) => {
      devices.overSpeedAlarms = []
    },
    lastPositionDeviceReset: (devices) => {
      devices.lastPositionDevice = undefined
    },
  },
})

export const resetLastPositionSearch = (dispatch: any) => {
  dispatch({
    type: slice.actions.positionSearchReset.type,
  })
}
export const resetLastPositionDevice = (dispatch: any) => {
  dispatch({
    type: slice.actions.lastPositionDeviceReset.type,
  })
}
export const resetOverSpeedAlarms = (dispatch: any) => {
  dispatch({
    type: slice.actions.periodicListReset.type,
  })
}
export const resetPeriodicList = (dispatch: any) => {
  dispatch({
    type: slice.actions.periodicListReset.type,
  })
}
export const resetOdo = (dispatch: any) => {
  dispatch({
    type: slice.actions.odoReset.type,
  })
}
export const resetTripsList = (dispatch: any) => {
  dispatch({
    type: slice.actions.tripListReset.type,
  })
}
export const resetOnStatus = (dispatch: any) => {
  dispatch({
    type: slice.actions.onStatusReset.type,
  })
}
export const resetOpenTrip = (dispatch: any) => {
  dispatch({
    type: slice.actions.openTripReset.type,
  })
}
export const deleteLastGeofence = (dispatch: any) => {
  dispatch({
    type: slice.actions.deleteGeofence.type,
  })
}
export const resetLastPosition = (dispatch: any) => {
  dispatch({
    type: slice.actions.lastPositionReset.type,
  })
}
export const resetactivitiesGeofence = (dispatch: any) => {
  dispatch({
    type: slice.actions.activitiesGeofenceReset.type,
  })
}
export const resetactivitiesGeofenceList = (dispatch: any) => {
  dispatch({
    type: slice.actions.activitiesGeofenceListReset.type,
  })
}
export const resetLatLng = (dispatch: any) => {
  dispatch({
    type: slice.actions.latLngReset.type,
  })
}
export const resetListGeofence = (dispatch: any) => {
  dispatch({
    type: slice.actions.listGeofenceReset.type,
  })
}
export const resetLastReObd = (dispatch: any) => {
  dispatch({
    type: slice.actions.LastReObdReset.type,
  })
}
export const resetDeviceSet = (dispatch: any) => {
  dispatch({
    type: slice.actions.deviceReset.type,
  })
}
export const resetTraveledDistance = (dispatch: any) => {
  dispatch({
    type: slice.actions.traveledDistanceSet.type,
  })
}
export const resetDeviceItem = (dispatch: any) => {
  dispatch({
    type: slice.actions.deviceSet.type,
  })
}
export const resetChartObd = (dispatch: any) => {
  dispatch({
    type: slice.actions.obdChartSet.type,
  })
}
export const resetTopObd = (dispatch: any) => {
  dispatch({
    type: slice.actions.topObdSet.type,
  })
}
export const resetPaginatedTrouble = (dispatch: any) => {
  dispatch({
    type: slice.actions.paginatedTroubleSet.type,
  })
}
export const resetLastTrouble = (dispatch: any) => {
  dispatch({
    type: slice.actions.lastTroubleSet.type,
  })
}
export const resetLastObd = (dispatch: any) => {
  dispatch({
    type: slice.actions.lastObdSet.type,
  })
}
export const setEngine = (dispatch: any) => {
  dispatch({
    type: slice.actions.engineSet.type,
  })
}
export const repairingObdReset = (dispatch: any) => {
  dispatch({
    type: slice.actions.repairingObdSet.type,
  })
}
export const resetEngineList = (dispatch: any) => {
  dispatch({
    type: slice.actions.resetEngine.type,
  })
}
export const resetTroubleCode = (dispatch: any) => {
  dispatch({
    type: slice.actions.troubleCodeReset.type,
  })
}
export const resetPositionList = (payload: any) => (dispatch: any) => {
  dispatch({
    type: slice.actions.positionListReset.type,
    payload,
  })
}
export const setTripList = (payload: any) => (dispatch: any) => {
  dispatch({
    type: slice.actions.tripsListSetReceived.type,
    payload,
  })
}
export const setError = (payload: any) => (dispatch: any) => {
  dispatch({
    type: slice.actions.errorSet.type,
    payload,
  })
}
export const setMessage = (payload: any) => (dispatch: any) => {
  dispatch({
    type: slice.actions.messageSet.type,
    payload,
  })
}
export const periodicDelete = (id: string) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/periodicservice/${id}`,
      method: 'DELETE',
      id,
      onStart: slice.actions.deletePeriodicRequested.type,
      onError: slice.actions.deletePeriodicRequestFailed.type,
      onSuccess: slice.actions.deletePeriodicReceived.type,
    }),
  )
}
export const searchDevice = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/device/search?pageIndex=0&pageSize=1000',
      method: 'POST',
      data,
      onStart: slice.actions.deviceSearchRequested.type,
      onError: slice.actions.deviceSearchRequestFailed.type,
      onSuccess: slice.actions.deviceSearchReceived.type,
    }),
  )
}

export const searchPosition = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/position/search?pageIndex=0&pageSize=1000',
      method: 'POST',
      data,
      onStart: slice.actions.positionSearchRequested.type,
      onError: slice.actions.positionSearchRequestFailed.type,
      onSuccess: slice.actions.positionSearchReceived.type,
    }),
  )
}
export const overSpeedAlarms = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/device/overspeedalarms?pageIndex=0&pageSize=1000',
      method: 'POST',
      data,
      onStart: slice.actions.overSpeedAlarmsRequested.type,
      onError: slice.actions.overSpeedAlarmsRequestFailed.type,
      onSuccess: slice.actions.overSpeedAlarmsReceived.type,
    }),
  )
}
export const offOverSpeedLimitation = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/order/overspeedlimitation',
      method: 'POST',
      data,
      onStart: slice.actions.offOverSpeedLimitRequested.type,
      onError: slice.actions.offOverSpeedLimitRequestFailed.type,
      onSuccess: slice.actions.offOverSpeedLimitReceived.type,
    }),
  )
}
export const overSpeedLimitation = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/order/overspeedlimitation',
      method: 'POST',
      data,
      onStart: slice.actions.setOverSpeedLimitRequested.type,
      onError: slice.actions.setOverSpeedLimitRequestFailed.type,
      onSuccess: slice.actions.setOverSpeedLimitReceived.type,
    }),
  )
}
export const periodicServiceList = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/periodicservice/list',
      method: 'POST',
      data,
      onStart: slice.actions.periodicListRequested.type,
      onError: slice.actions.periodicListRequestFailed.type,
      onSuccess: slice.actions.periodicListReceived.type,
    }),
  )
}
export const createPeriodicService = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/periodicservice/create',
      method: 'POST',
      data,
      onStart: slice.actions.createPeriodicRequested.type,
      onError: slice.actions.createPeriodicRequestFailed.type,
      onSuccess: slice.actions.createPeriodicReceived.type,
    }),
  )
}
export const updatePeriodicService = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/periodicservice/update',
      method: 'PUT',
      data,
      onStart: slice.actions.updatePeriodicRequested.type,
      onError: slice.actions.updatePeriodicRequestFailed.type,
      onSuccess: slice.actions.updatePeriodicReceived.type,
    }),
  )
}
export const listTrips = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/trip/paginatedlist?pageIndex=0&pageSize=1000',
      method: 'POST',
      data,
      onStart: slice.actions.listTripRequested.type,
      onError: slice.actions.listTripRequestFailed.type,
      onSuccess: slice.actions.listTripReceived.type,
    }),
  )
}
export const GeofenceCreate = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/geofence/create',
      method: 'POST',
      data,
      onStart: slice.actions.createGeofenceRequested.type,
      onError: slice.actions.createGeofenceRequestFailed.type,
      onSuccess: slice.actions.createGeofenceReceived.type,
    }),
  )
}
export const startTrip = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/trip/start',
      method: 'POST',
      data,
      onStart: slice.actions.startTripRequested.type,
      onError: slice.actions.startTripRequestFailed.type,
      onSuccess: slice.actions.startTripReceived.type,
    }),
  )
}
export const endTrip = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/trip/end',
      method: 'POST',
      data,
      onStart: slice.actions.endTripRequested.type,
      onError: slice.actions.endTripRequestFailed.type,
      onSuccess: slice.actions.endTripReceived.type,
    }),
  )
}
export const GeofenceActivities = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/geofence/activities?pageIndex=0&pageSize=1000',
      method: 'POST',
      data,
      onStart: slice.actions.activitiesGeofenceRequested.type,
      onError: slice.actions.activitiesGeofenceRequestFailed.type,
      onSuccess: slice.actions.activitiesGeofenceReceived.type,
    }),
  )
}
export const GeofenceActivitiesList = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/geofence/activities?pageIndex=0&pageSize=1000',
      method: 'POST',
      data,
      onStart: slice.actions.activitiesGeofenceListRequested.type,
      onError: slice.actions.activitiesGeofenceListRequestFailed.type,
      onSuccess: slice.actions.activitiesGeofenceListReceived.type,
    }),
  )
}
export const GeofenceDelete = (id: string) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/geofence/${id}`,
      method: 'DELETE',
      id,
      onStart: slice.actions.deleteGeofenceRequested.type,
      onError: slice.actions.deleteGeofenceRequestFailed.type,
      onSuccess: slice.actions.deleteGeofenceReceived.type,
    }),
  )
}
export const tripDelete = (id: string) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/trip/${id}`,
      method: 'DELETE',
      id,
      onStart: slice.actions.deleteTripRequested.type,
      onError: slice.actions.deleteTripRequestFailed.type,
      onSuccess: slice.actions.deleteTripReceived.type,
    }),
  )
}
export const tripDeleteOpen = (id: string) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/trip/${id}`,
      method: 'DELETE',
      id,
      onStart: slice.actions.deleteTripOpenRequested.type,
      onError: slice.actions.deleteTripOpenRequestFailed.type,
      onSuccess: slice.actions.deleteTripOpenReceived.type,
    }),
  )
}
export const lastPosition = (id: string) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/trip/lastposition/${id}`,
      method: 'GET',
      id,
      onStart: slice.actions.lastPositionGetRequested.type,
      onError: slice.actions.lastPositionGetRequestFailed.type,
      onSuccess: slice.actions.lastPositionGetReceived.type,
    }),
  )
}
export const openedTrips = (id: string) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/trip/opened/${id}`,
      method: 'GET',
      id,
      onStart: slice.actions.openTripsGetRequested.type,
      onError: slice.actions.openTripsGetRequestFailed.type,
      onSuccess: slice.actions.openTripsGetReceived.type,
    }),
  )
}
export const GeofencesList = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/geofence/list',
      method: 'POST',
      data,
      onStart: slice.actions.listGeofenceRequested.type,
      onError: slice.actions.listGeofenceRequestFailed.type,
      onSuccess: slice.actions.listGeofenceReceived.type,
    }),
  )
}
export const troubleCodeClear = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/order/cleartroublecode',
      method: 'POST',
      data,
      onStart: slice.actions.setTroubleCodeClearRequested.type,
      onError: slice.actions.setTroubleCodeClearRequestFailed.type,
      onSuccess: slice.actions.setTroubleCodeClearReceived.type,
    }),
  )
}
export const getEngineDetails = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/obd/paginatedlist',
      method: 'POST',
      data: {
        deviceId: data.deviceId,
        startDateTime: data.startDateTime,
        endDateTime: data.endDateTime,
      },
      params: { pageIndex: data.pageIndex, pageSize: data.pageSize },
      onStart: slice.actions.engineDetailsRequested.type,
      onError: slice.actions.engineDetailsRequestFailed.type,
      onSuccess: slice.actions.engineDetailsReceived.type,
    }),
  )
}
export const setOffRepairing = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/order/repairingobdoffinterval',
      method: 'POST',
      data,
      onStart: slice.actions.offRepairingRequested.type,
      onError: slice.actions.offRepairingRequestFailed.type,
      onSuccess: slice.actions.offRepairingReceived.type,
    }),
  )
}

export const registerDevice = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/device/register',
      method: 'POST',
      data,
      onStart: slice.actions.registerDeviceRequested.type,
      onError: slice.actions.registerDeviceRequestFailed.type,
      onSuccess: slice.actions.registerDeviceReceived.type,
    }),
  )
}
export const deviceList = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/device/list',
      method: 'POST',
      data,
      onStart: slice.actions.deviceListRequested.type,
      onError: slice.actions.deviceListRequestFailed.type,
      onSuccess: slice.actions.deviceListReceived.type,
    }),
  )
}
export const devicePaginatedList = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: 'device/paginatedlist',
      method: 'POST',
      data,
      params: { pageIndex: data.pageIndex, pageSize: data.pageSize },
      onStart: slice.actions.devicePaginatedListRequested.type,
      onError: slice.actions.devicePaginatedListRequestFailed.type,
      onSuccess: slice.actions.devicePaginatedListReceived.type,
    }),
  )
}
export const resetDevice = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/device/reset',
      method: 'POST',
      data,
      onStart: slice.actions.resetDeviceRequested.type,
      onError: slice.actions.resetDeviceRequestFailed.type,
      onSuccess: slice.actions.resetDeviceReceived.type,
    }),
  )
}
export const updateDevice = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/device/update',
      method: 'PUT',
      data,
      onStart: slice.actions.updateDeviceRequested.type,
      onError: slice.actions.updateDeviceRequestFailed.type,
      onSuccess: slice.actions.updateDeviceReceived.type,
    }),
  )
}
export const LastPositionDevice = (id: string) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/position/last/${id}`,
      method: 'GET',
      id,
      onStart: slice.actions.getLastPositionDeviceRequested.type,
      onError: slice.actions.getLastPositionDeviceRequestFailed.type,
      onSuccess: slice.actions.getLastPositionDeviceReceived.type,
    }),
  )
}
export const getLastPosition = (id: string) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/position/last/${id}`,
      method: 'GET',
      id,
      onStart: slice.actions.getLastPositionRequested.type,
      onError: slice.actions.getLastPositionRequestFailed.type,
      onSuccess: slice.actions.getLastPositionReceived.type,
    }),
  )
}
export const getPositionList = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/position/list`,
      method: 'POST',
      data,
      onStart: slice.actions.positionListRequested.type,
      onError: slice.actions.positionListRequestFailed.type,
      onSuccess: slice.actions.positionListReceived.type,
    }),
  )
}
export const troubleCodeRead = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/order/readtroublecode`,
      method: 'POST',
      data,
      onStart: slice.actions.troubleCodeReadRequested.type,
      onError: slice.actions.troubleCodeReadRequestFailed.type,
      onSuccess: slice.actions.troubleCodeReadReceived.type,
    }),
  )
}
export const troubleCodeClear1 = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/order/cleartroublecode`,
      method: 'POST',
      data,
      onStart: slice.actions.troubleCodeClearRequested.type,
      onError: slice.actions.troubleCodeClearRequestFailed.type,
      onSuccess: slice.actions.troubleCodeClearReceived.type,
    }),
  )
}
export const getLastObd = (id: string) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/obd/last/${id}`,
      method: 'GET',
      id,
      onStart: slice.actions.lastObdRequested.type,
      onError: slice.actions.lastObdRequestFailed.type,
      onSuccess: slice.actions.lastObdReceived.type,
    }),
  )
}
export const setRepairingObd = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/order/repairingobdinterval`,
      method: 'POST',
      data,
      onStart: slice.actions.repairingObdRequested.type,
      onError: slice.actions.repairingObdRequestFailed.type,
      onSuccess: slice.actions.repairingObdReceived.type,
    }),
  )
}
export const getLastReObd = (id: string) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/obd/last/re/${id}`,
      method: 'GET',
      id,
      onStart: slice.actions.lastReObdRequested.type,
      onError: slice.actions.lastReObdRequestFailed.type,
      onSuccess: slice.actions.lastReObdReceived.type,
    }),
  )
}
export const getLastTrouble = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/troublecode/last/list`,
      method: 'POST',
      data,
      onStart: slice.actions.lastTroubleRequested.type,
      onError: slice.actions.lastTroubleRequestFailed.type,
      onSuccess: slice.actions.lastTroubleReceived.type,
    }),
  )
}
export const getLastTrouble1 = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/troublecode/last/list`,
      method: 'POST',
      data,
      onStart: slice.actions.lastTrouble1Requested.type,
      onError: slice.actions.lastTrouble1RequestFailed.type,
      onSuccess: slice.actions.lastTrouble1Received.type,
    }),
  )
}
export const getPaginatedTrouble = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/troublecode/paginatedlist?pageIndex=0&pageSize=1000',
      method: 'POST',
      data,
      onStart: slice.actions.paginatedTroubleRequested.type,
      onError: slice.actions.paginatedTroubleRequestFailed.type,
      onSuccess: slice.actions.paginatedTroubleReceived.type,
    }),
  )
}
export const getTopObd = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/obd/top',
      method: 'POST',
      data,
      onStart: slice.actions.topObdRequested.type,
      onError: slice.actions.topObdRequestFailed.type,
      onSuccess: slice.actions.topObdReceived.type,
    }),
  )
}
export const getObdChart = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/obd/chart?pageIndex=0&pageSize=1000',
      method: 'POST',
      data,
      onStart: slice.actions.paginatedObdChartRequested.type,
      onError: slice.actions.paginatedObdChartRequestFailed.type,
      onSuccess: slice.actions.paginatedObdChartReceived.type,
    }),
  )
}
export const getOdo = (id: string) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/obd/odo/${id}`,
      method: 'GET',
      id,
      onStart: slice.actions.odoRequested.type,
      onError: slice.actions.odoRequestFailed.type,
      onSuccess: slice.actions.odoReceived.type,
    }),
  )
}
export const getTraveledDistance = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/position/travelleddistance?pageIndex=0&pageSize=1000&loadAllTripsAsSingle=true',
      method: 'POST',
      data,
      onStart: slice.actions.traveledDistanceRequested.type,
      onError: slice.actions.traveledDistanceRequestFailed.type,
      onSuccess: slice.actions.traveledDistanceReceived.type,
    }),
  )
}

export const getDevice = (id: string) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/device/${id}`,
      method: 'GET',
      id,
      onStart: slice.actions.deviceRequested.type,
      onError: slice.actions.deviceRequestFailed.type,
      onSuccess: slice.actions.deviceReceived.type,
    }),
  )
}
export const getDeviceStatus = (id: string) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: `/device/status/${id}`,
      method: 'GET',
      id,
      onStart: slice.actions.deviceStatusRequested.type,
      onError: slice.actions.deviceStatusRequestFailed.type,
      onSuccess: slice.actions.deviceStatusReceived.type,
    }),
  )
}
export const getTopObdsChart = (data: any) => (dispatch: any) => {
  return dispatch(
    apiCallBegan({
      baseURL: routes.BASE_URL,
      url: '/obd/topchart',
      method: 'POST',
      data,
      onStart: slice.actions.topObdsChartRequested.type,
      onError: slice.actions.topObdsChartRequestFailed.type,
      onSuccess: slice.actions.topObdsChartReceived.type,
    }),
  )
}

export const getDeviceList = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.list,
)
export const getError = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.error,
)
export const getMessage = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.message,
)
export const getLatiTude = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.latitude,
)
export const getLongiTude = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.longitude,
)
export const getLoading = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.loading,
)
export const getTripList = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.tripList,
)
export const getPositionLists = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.positionList,
)
export const getEngine = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.engine,
)
export const getObdLast = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.lastObd,
)
export const getRepairingObd = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.repairingObd,
)
export const getTroubleLast = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.lastTrouble,
)
export const getTroubleLast1 = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.lastTrouble1,
)
export const getTroublePaginated = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.paginatedTrouble,
)
export const getObdTop = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.topObd,
)
export const getChartObd = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.obdChart,
)
export const getOdoItem = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.odo,
)
export const getDistanceTraveled = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.traveledDistance,
)
export const getDeviceInfo = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.device,
)
export const getReObdLast = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.device,
)
export const getStatusDevice = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.deviceStatus,
)
export const getObdsTopChart = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.topObdsChart,
)
export const getGeofenceList = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.listGeofence,
)
export const getGeofenceActivities = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.activitiesGeofence,
)
export const getGeofenceActivitiesList = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.activitiesGeofenceList,
)
export const getGeofenceCreate = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.createGeofence,
)
export const getPositionLast = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.lastPosition,
)
export const getOpenTrips = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.openTrips,
)
export const getOnStatusDevice = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.onStatus,
)
export const getListTrips = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.listTrips,
)
export const getRefreshToken = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.refreshToken,
)
export const getPeriodicServiceList = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.periodicList,
)
export const getOnlyDevice = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.onlyDevice,
)
export const getOverSpeedAlarms = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.overSpeedAlarms,
)
export const getOverSpeed = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.setOverSpeed,
)
export const getLastPositionDevice = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.lastPositionDevice,
)
export const getdeviceSearch = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.deviceSearch,
)
export const getTroubleCodeRead = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.troubleCodeRead,
)
export const getTroubleCodeClear1 = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.troubleCodeClear1,
)
export const getPaginatedList = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.devicePaginatedList,
)
export const getDevicePaginated = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.devicePaginated,
)
export const getSearchPosition = createSelector(
  (state: any) => state.entities.devices,
  (devices: any) => devices.positionSearch,
)

export default slice.reducer
